import React, { useState } from "react";
import "./ConfuciusGame.css";

const gcd = (a, b) => {
  while (b) {
    [a, b] = [b, a % b];
  }
  return a;
};

const lcm = (a, b) => (a * b) / gcd(a, b);

const ConfuciusGame = () => {
    
  const InitialSet = [12, 45, 20, 14, 27, 30];
  const [Set, setSet] = useState(InitialSet);
  const [SelectedNumbers, setSelectedNumbers] = useState([]);
  const [Message, setMessage] = useState(null)
  const [Animating, setAnimating] = useState([]);

  const selectNumber = (index) => {
    if (SelectedNumbers.includes(index)) {
      setSelectedNumbers(SelectedNumbers.filter((x) => x !== index));
      return;
    }
    if (SelectedNumbers.length === 2) return;
    setSelectedNumbers([...SelectedNumbers, index]);
    return;
  };

  const MakeMove = (Set,SelectedNumbers)=>{
    const newSet = [...Set];

const i = SelectedNumbers[0];
const j = SelectedNumbers[1];

const g = gcd(Set[i], Set[j]);

newSet[i] = g;
newSet[j] = lcm(Set[i], Set[j]) / g;

return newSet;
  }
  
  const isLegal = (SelectedNumbers)=> (SelectedNumbers.length === 2 && Set[SelectedNumbers[0]]>1 && Set[SelectedNumbers[1]]>1)
  return (
    <div className="ConfuciusGame-container">
        {Message ?<h3>{Message}</h3>:null}
      <div className="Board">
        {Set.map((num, index) => (
          <div
  key={index}
  className={`Tile
    ${SelectedNumbers.includes(index) ? "Selected" : ""}
    ${Animating.includes(index) ? "Changing" : ""}
  `}
  onClick={() => selectNumber(index)}
>
  {num}
</div>
        ))}
      </div>
      <div className="Buttons-Container">
        <button
  className="Green"
  onClick={async () => {
    const legal = isLegal(SelectedNumbers);

    if (!legal) {
      setMessage("❌ Illegal move! You have to choose TWO integers >1.");
      return;
    }

    setMessage(null);

    // Highlight the tiles
    setAnimating([...SelectedNumbers]);

    // Wait 600ms
    await new Promise(resolve => setTimeout(resolve, 600));

    const newSet = MakeMove(Set, SelectedNumbers);

    setSet(newSet);
    setAnimating([]);
    setSelectedNumbers([]);
  }}
>
  Make a Move
</button>
        <button className="Red" onClick={()=>{
            setSet(InitialSet)
setMessage(null)
setSelectedNumbers([])
        }}>Repeat </button>
      </div>
    </div>
  );
};

export default ConfuciusGame;
